import { render, staticRenderFns } from "./WxKanban.vue?vue&type=template&id=15aac2b2&scoped=true&"
import script from "./WxKanban.vue?vue&type=script&lang=js&"
export * from "./WxKanban.vue?vue&type=script&lang=js&"
import style0 from "./WxKanban.vue?vue&type=style&index=0&id=15aac2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aac2b2",
  null
  
)

export default component.exports